(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const registry = new Map();
  const root = window.Shopify?.routes?.root || '/';
  function register(el, cleanup) { registry.set(el, cleanup); }
  function initSlideshow(el) {
    if (registry.has(el)) return;
    const slides = [...el.querySelectorAll('[data-slide]')];
    if (!slides.length) return;
    const dots = [...el.querySelectorAll('[data-slide-to]')];
    const pause = el.querySelector('[data-slide-pause]');
    let current = 0, stopped = motion.matches, hovered = false, focused = false, visible = false, lastTouch = 0;
    function render(next) {
      current = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { const active = i === current; slide.classList.toggle('is-active', active); slide.inert = !active; slide.setAttribute('aria-hidden', String(!active)); });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
    }
    function updatePause() { if (!pause) return; pause.querySelector('[data-pause-icon]')?.toggleAttribute('hidden', stopped); pause.querySelector('[data-play-icon]')?.toggleAttribute('hidden', !stopped); pause.setAttribute('aria-label', stopped ? 'Play slideshow' : 'Pause slideshow'); pause.setAttribute('aria-pressed', String(stopped)); }
    el.querySelector('[data-slide-prev]')?.addEventListener('click', () => { lastTouch = Date.now(); render(current - 1); });
    el.querySelector('[data-slide-next]')?.addEventListener('click', () => { lastTouch = Date.now(); render(current + 1); });
    dots.forEach(dot => dot.addEventListener('click', () => { lastTouch = Date.now(); render(Number(dot.dataset.slideTo)); }));
    pause?.addEventListener('click', () => { stopped = !stopped; updatePause(); });
    el.addEventListener('mouseenter', () => hovered = matchMedia('(hover: hover) and (pointer: fine)').matches); el.addEventListener('mouseleave', () => hovered = false);
    el.addEventListener('focusin', () => focused = true); el.addEventListener('focusout', e => focused = el.contains(e.relatedTarget));
    let startX = 0, startY = 0;
    el.addEventListener('touchstart', e => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; lastTouch = Date.now(); }, { passive: true });
    el.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) render(current + (dx < 0 ? 1 : -1)); }, { passive: true });
    const observer = new IntersectionObserver(([entry]) => visible = entry.isIntersecting, { threshold: .15 }); observer.observe(el);
    const timer = setInterval(() => { if (visible && !document.hidden && !stopped && !hovered && !focused && !motion.matches && Date.now() - lastTouch > 9000) render(current + 1); }, Number(el.dataset.interval) || 6500);
    const preference = () => { stopped = motion.matches; updatePause(); }; motion.addEventListener('change', preference);
    render(0); updatePause(); register(el, () => { clearInterval(timer); observer.disconnect(); motion.removeEventListener('change', preference); });
  }
  function initMultiHero(el) {
    if (registry.has(el)) return;
    const track = el.querySelector('[data-multi-hero-track]');
    const panels = [...el.querySelectorAll('[data-multi-hero-panel]')];
    if (!track || !panels.length) return;
    const mobile = matchMedia('(max-width: 749px)');
    let activeIndex = 0, visible = false, lastInteraction = 0;
    const goTo = index => {
      activeIndex = (index + panels.length) % panels.length;
      track.scrollTo({ left: panels[activeIndex].offsetLeft, behavior: motion.matches ? 'auto' : 'smooth' });
    };
    const move = direction => { lastInteraction = Date.now(); goTo(activeIndex + direction); };
    const previous = () => move(-1);
    const next = () => move(1);
    el.querySelector('[data-multi-hero-prev]')?.addEventListener('click', previous);
    el.querySelector('[data-multi-hero-next]')?.addEventListener('click', next);
    const updateActivePanel = () => {
      const centre = track.scrollLeft + (track.clientWidth / 2);
      let active = panels[0];
      let distance = Infinity;
      panels.forEach(panel => {
        const panelCentre = panel.offsetLeft + (panel.offsetWidth / 2);
        const nextDistance = Math.abs(panelCentre - centre);
        if (nextDistance < distance) { active = panel; distance = nextDistance; }
      });
      activeIndex = panels.indexOf(active);
      panels.forEach(panel => panel.classList.toggle('is-active', panel === active));
    };
    const noteInteraction = () => lastInteraction = Date.now();
    track.addEventListener('scroll', updateActivePanel, { passive: true });
    track.addEventListener('pointerdown', noteInteraction, { passive: true });
    track.addEventListener('touchstart', noteInteraction, { passive: true });
    const observer = new IntersectionObserver(([entry]) => visible = entry.isIntersecting, { threshold: .35 });
    observer.observe(el);
    const timer = setInterval(() => {
      if (!mobile.matches || !visible || document.hidden || motion.matches || Date.now() - lastInteraction < 6000) return;
      goTo(activeIndex + 1);
    }, 3000);
    updateActivePanel();
    register(el, () => {
      clearInterval(timer);
      observer.disconnect();
      el.querySelector('[data-multi-hero-prev]')?.removeEventListener('click', previous);
      el.querySelector('[data-multi-hero-next]')?.removeEventListener('click', next);
      track.removeEventListener('scroll', updateActivePanel);
      track.removeEventListener('pointerdown', noteInteraction);
      track.removeEventListener('touchstart', noteInteraction);
    });
  }
  function initRail(track) {
    if (registry.has(track)) return;
    const section = track.closest('section');
    let visible = false, hovered = false, paused = false, lastTouch = 0;
    const control = document.createElement('div'); control.className = 'rail-play-control';
    const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Ⅱ Pause movement'; button.setAttribute('aria-pressed', 'false'); control.append(button); track.insertAdjacentElement('afterend', control);
    button.addEventListener('click', () => { paused = !paused; button.textContent = paused ? '▶ Play movement' : 'Ⅱ Pause movement'; button.setAttribute('aria-pressed', String(paused)); });
    const observer = new IntersectionObserver(([entry]) => visible = entry.isIntersecting, { threshold: .15 }); observer.observe(track);
    track.addEventListener('mouseenter', () => hovered = matchMedia('(hover: hover) and (pointer: fine)').matches); track.addEventListener('mouseleave', () => hovered = false);
    track.addEventListener('pointerdown', () => lastTouch = Date.now(), { passive: true });
    track.addEventListener('wheel', () => lastTouch = Date.now(), { passive: true });
    section?.addEventListener('click', () => lastTouch = Date.now());
    const timer = setInterval(() => {
      if (!visible || document.hidden || paused || hovered || motion.matches || track.contains(document.activeElement) || Date.now() - lastTouch < 12000) return;
      const max = track.scrollWidth - track.clientWidth; if (max < 5) return;
      const card = track.firstElementChild; const gap = parseFloat(getComputedStyle(track).gap) || 14;
      const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * .7;
      track.scrollTo({ left: track.scrollLeft >= max - 5 ? 0 : Math.min(max, track.scrollLeft + amount), behavior: 'smooth' });
    }, 4500);
    register(track, () => { clearInterval(timer); observer.disconnect(); control.remove(); });
  }
  function initCoverflow(el) {
    if (registry.has(el)) return;
    let visible = false, hovered = false, lastTouch = 0;
    const observer = new IntersectionObserver(([entry]) => visible = entry.isIntersecting, { threshold: .3 }); observer.observe(el);
    el.addEventListener('mouseenter', () => hovered = matchMedia('(hover: hover) and (pointer: fine)').matches); el.addEventListener('mouseleave', () => hovered = false);
    el.addEventListener('pointerdown', () => lastTouch = Date.now(), { passive: true });
    const control = document.createElement('div'); control.className = 'rail-play-control'; const button = document.createElement('button'); button.textContent = 'Ⅱ Pause movement'; button.type = 'button'; control.append(button); el.append(control); let paused = false;
    button.addEventListener('click', () => { paused = !paused; button.textContent = paused ? '▶ Play movement' : 'Ⅱ Pause movement'; button.setAttribute('aria-pressed', String(paused)); });
    const timer = setInterval(() => { if (visible && !hovered && !paused && !document.hidden && !motion.matches && !el.contains(document.activeElement) && Date.now() - lastTouch > 12000) el._moveCover?.(1); }, 4200);
    register(el, () => { clearInterval(timer); observer.disconnect(); control.remove(); });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    scope.querySelectorAll('[data-multi-hero]').forEach(initMultiHero);
    scope.querySelectorAll('[data-auto-rail],.template-index .product-rail [data-track],.template-index .trending [data-track]').forEach(initRail);
    scope.querySelectorAll('[data-coverflow]').forEach(initCoverflow);
  }
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-upsell-variant]')) return;
    const item = e.target.closest('.upsell-item'); const button = item?.querySelector('[data-upsell-add]');
    if (!button) return; button.dataset.variantId = e.target.value; button.disabled = !e.target.value;
  });
  document.addEventListener('click', async e => {
    const button = e.target.closest('[data-upsell-add]'); if (!button) return;
    const item = button.closest('.upsell-item'); const status = item.querySelector('[data-upsell-status]'); const variantId = button.dataset.variantId;
    if (!variantId || item.dataset.busy === 'true') return;
    item.dataset.busy = 'true'; button.disabled = true; button.textContent = '…'; status.textContent = '';
    const body = new FormData(); body.append('id', variantId); body.append('quantity', '1');
    try { const response = await fetch(`${root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' }, credentials: 'same-origin' }); const data = await response.json(); if (!response.ok) throw new Error(data.description || 'Could not add this jacket.'); button.textContent = '✓'; document.dispatchEvent(new CustomEvent('wtf:cart-added')); }
    catch (error) { status.textContent = error.message; button.textContent = '+'; }
    finally { item.dataset.busy = 'false'; if (button.isConnected) button.disabled = !button.dataset.variantId; }
  });
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => { for (const [el, cleanup] of registry) if (e.target.contains(el)) { cleanup(); registry.delete(el); } });
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('[data-slide]');
    if (slide) { const slider = slide.closest('[data-slideshow]'); const index = [...slider.querySelectorAll('[data-slide]')].indexOf(slide); slider.querySelector(`[data-slide-to="${index}"]`)?.click(); }
    const panel = e.target.closest('[data-multi-hero-panel]');
    if (panel) panel.scrollIntoView({ behavior: motion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
  });
  init();
})();
